import React, { Fragment, useCallback, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
    Col,
    Row,
    Button,
    FormGroup,
    Form,
    Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../Context/Auth/AuthContext';
import classnames from 'classnames';
import UserRoles from '../../../enums/UserRoles';
import InputMask from 'react-input-mask';

// const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const schema = Yup.object().shape({
    email: Yup.string().email('Email invalid!').required('Email is required!'),
    name: Yup.string().required('Name is required!'),
    // phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
    password: Yup.string()
        .required('Password is required!')
        .min(6, 'Password must be at least 6 characters'),
    passwordrep: Yup.string()
        .required('Confirm password is required!')
        .oneOf([Yup.ref('password'), null], 'Passwords must match'),
    role: Yup.string().required('Select a role!')
});

const strongSchema = Yup.object().shape({
    email: Yup.string().email('Email invalid!').required('Email is required!'),
    name: Yup.string().required('Name is required!'),
    // phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
    password: Yup.string()
        .required('Please Enter your password')
        .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            "Must contain at least: 8 characters, one uppercase, one lowercase, one number and one special symbol"
        ),
    passwordrep: Yup.string()
        .required('Confirm password is required!')
        .oneOf([Yup.ref('password'), null], 'Passwords must match'),
    role: Yup.string().required('Select a role!')
});

export default function SignUp(props) {
    const { match } = props;
    
    // Strong password Schema selection
    const strongPassword = process.env.REACT_APP_STRONG_PASSWORD;
    var schemaToUse = schema;
    if (strongPassword === "true") {
        schemaToUse = strongSchema;
    }

    const history = useHistory();
    const { register, errors, handleSubmit } = useForm({
        validationSchema: schemaToUse,
    });
    const { toggleLoading } = useAuth();

    const webPageUrl = process.env.REACT_APP_WEB_PAGE_URL;

    const [modalConfirm, setModalConfirm] = useState(false);
    const toggleModalConfirm = useCallback(() => {
        setModalConfirm(!modalConfirm);
    }, [modalConfirm, setModalConfirm]);

    const [submitData, setSubmitData] = useState();

    const roles = [
        { value: 'coordinator', label: 'Coordinator', selected: false },
        { value: 'giver', label: 'Volunteer', selected: false },
        { value: 'receiver', label: 'Participant', selected: false },
    ];
    const rolesMap = {
        coordinator: 'coordinator',
        volunteer: 'giver',
        participant: 'receiver',
    };

    const [defaultRole] = useState(rolesMap[match.params.role]);

    const onSubmit = useCallback(
        async (data) => {
            setSubmitData(data);
            toggleModalConfirm();
        },
        [toggleModalConfirm]
    );

    const endSubmit = useCallback(
        async () => {
            toggleModalConfirm();
            toggleLoading(true);
            const data = submitData;
            delete data.passwordrep;
            data.email = data.email.toLowerCase();
            data.email = data.email.trim();

            const rolesCodeMap = {
                coordinator: UserRoles.COORDINATOR,
                giver: UserRoles.GIVER,
                receiver: UserRoles.RECEIVER,
            };
            data.role = rolesCodeMap[data.role];

            try {
                const response = await api.post('/ro.team.signup', data);
                if (response.status === 200) {
                    // toast.info(response.data.message);
                    // await signIn({
                    //     email: data.email,
                    //     password: data.password,
                    // });
                    history.push(`/confirm-signup/${data.email}`);
                    // history.push('/');
                    toggleLoading(false);
                }
            } catch (err) {
                const message = (err.response.data.message && err.response.data.message.message) ? 
                    err.response.data.message.message : 
                    'Error on Sign up. Please Try Again later';
                
                toast.error(message);

                toggleLoading(false);
                return false;
            }
        },
        [history, toggleLoading, toggleModalConfirm, submitData]
    );

    const [modalTermsConditions, setModalTermsConditions] = useState(false);
    const toggleModalTermsConditions = useCallback(() => {
        setModalTermsConditions(!modalTermsConditions);
    }, [modalTermsConditions, setModalTermsConditions]);

    const [modalPrivay, setModalPrivay] = useState(false);
    const toggleModalPrivacy = useCallback(() => {
        setModalPrivay(!modalPrivay);
    }, [modalPrivay, setModalPrivay]);

    const openTerms = (e) => {
        e.preventDefault();
        toggleModalTermsConditions();
    };

    const openPrivacy = (e) => {
        e.preventDefault();
        toggleModalPrivacy();
    };

    const [width] = useState(window.innerWidth);

    return (
        <Fragment>
            <div
                className={classnames('bg-animation', {
                    'h-100': width > 1400,
                })}
            >
                <div
                    className={classnames(
                        'd-flex justify-content-center align-items-center',
                        {
                            'h-100': width > 1400,
                        }
                    )}
                >
                    <Col md="8" className="mx-auto app-login-box">
                        <a href={webPageUrl} target="_blank" rel="noopener noreferrer">
                            <div className="app-logo-inverse mx-auto mb-3" />
                        </a>

                        <div className="modal-dialog w-100">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="h5 modal-title text-center">
                                        <h4 className="mt-2">
                                            <div>Welcome!</div>
                                            <span>
                                                Seniors Living In Neighborhood Kindness
                                            </span>
                                        </h4>
                                    </div>
                                    <Row className="divider" />
                                    <Form onSubmit={handleSubmit(onSubmit)}>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        id="exampleName"
                                                        placeholder="Name"
                                                        ref={register}
                                                        className="form-control"
                                                    />
                                                    {errors.name && (
                                                        <p className="error-validation">
                                                            {
                                                                errors.name
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        id="exampleEmail"
                                                        placeholder="Email"
                                                        ref={register}
                                                        className="form-control"
                                                    />
                                                    {errors.email && (
                                                        <p className="error-validation">
                                                            {
                                                                errors.email
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    {/* <input
                                                        type="text"
                                                        name="phone"
                                                        id="examplePhone"
                                                        placeholder="Phone (Optional)"
                                                        ref={register}
                                                        className="form-control"
                                                    /> */}
                                                    <InputMask
                                                        mask="(999) 999-9999"
                                                        type="text"
                                                        name="phone"
                                                        id="examplePhone"
                                                        placeholder="Phone (Optional)"
                                                        inputRef={register}
                                                        className="form-control"
                                                    />
                                                    {errors.phone && (
                                                        <p className="error-validation">
                                                            {
                                                                errors.phone
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <input
                                                        type="password"
                                                        name="password"
                                                        id="examplePassword"
                                                        placeholder="Password"
                                                        ref={register}
                                                        className="form-control"
                                                    />
                                                    {errors.password && (
                                                        <p className="error-validation">
                                                            {
                                                                errors.password
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <input
                                                        type="password"
                                                        name="passwordrep"
                                                        id="examplePasswordRep"
                                                        placeholder="Repeat Password"
                                                        ref={register}
                                                        className="form-control"
                                                    />
                                                    {errors.passwordrep && (
                                                        <p className="error-validation">
                                                            {
                                                                errors
                                                                    .passwordrep
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={12} className="mt-4">
                                                <FormGroup>
                                                    <select
                                                        id="role"
                                                        name="role"
                                                        className="form-control"
                                                        ref={register}
                                                        defaultValue={
                                                            defaultRole
                                                        }
                                                    >
                                                        <option value="">
                                                            Select your role
                                                        </option>
                                                        {roles &&
                                                            roles.map(
                                                                (role) => (
                                                                    <option
                                                                        key={
                                                                            role.value
                                                                        }
                                                                        value={
                                                                            role.value
                                                                        }
                                                                    >
                                                                        {
                                                                            role.label
                                                                        }
                                                                    </option>
                                                                )
                                                            )}
                                                    </select>
                                                    {errors.role && (
                                                        <p className="error-validation">
                                                            {
                                                                errors
                                                                    .role
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <div className="text-center">
                                                    <small>
                                                        By signing up you agree
                                                        with our{' '}
                                                        <a
                                                            href="#/"
                                                            onClick={openTerms}
                                                        >
                                                            terms and conditions
                                                        </a>{' '}
                                                        and{' '}
                                                        <a
                                                            href="#/"
                                                            onClick={
                                                                openPrivacy
                                                            }
                                                        >
                                                            privacy policy
                                                        </a>
                                                        .
                                                    </small>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                    {/* <FormGroup className="mt-3" check>
                                        <Input
                                            type="checkbox"
                                            name="check"
                                            id="exampleCheck"
                                        />
                                        <Label for="exampleCheck" check>
                                            Accept our{' '}
                                            <a
                                                href="https://colorlib.com/"
                                                onClick={(e) =>
                                                    e.preventDefault()
                                                }
                                            >
                                                Terms and Conditions
                                            </a>
                                            .
                                        </Label>
                                    </FormGroup> */}
                                    <Row className="divider" />
                                    <h6 className="mb-0">
                                        Already have an account?{' '}
                                        <Link className="text-primary" to="/">
                                            Sign in
                                        </Link>{' '}
                                        |{' '}
                                        <Link
                                            className="text-primary"
                                            to="/forgot-password"
                                        >
                                            Forgot Password?
                                        </Link>
                                    </h6>
                                </div>
                                <div className="modal-footer d-block text-center">
                                    <Button
                                        color="primary"
                                        className="btn-wide btn-pill btn-shadow btn-hover-shine"
                                        size="lg"
                                        onClick={handleSubmit(onSubmit)}
                                    >
                                        Create Account
                                    </Button>
                                </div>
                            </div>
                        </div>
                        {/* <div className="text-center text-white opacity-8 mt-3">
                            Copyright &copy; ArchitectUI 2019
                        </div> */}
                    </Col>
                </div>
            </div>

            <Modal
                isOpen={modalTermsConditions}
                toggle={toggleModalTermsConditions}
            >
                <ModalHeader toggle={toggleModalTermsConditions}>
                    Terms and Conditions
                </ModalHeader>
                <ModalBody>
                <p><strong>Senior Link Terms of Service for Your Personal Use</strong></p><p>
  Welcome! By using the  Senior Link Web App, website, and other services provided by the Senior Link  Project, (&quot;Senior Link&quot; or &ldquo;The Project&rdquo;), you agree with the terms  and conditions described below.</p>

 <p>The motivation for Senior Link started in the pandemic of 2020 when more seniors were isolated. The main idea was to facilitate the creation of volunteer groups to connect with seniors in the community and help to reduce their social isolation.
    This process starts with a Coordinator who creates a Senior Link group, enters the names of Seniors in the community who agreed to participate, and invites Volunteers who are willing and able to contact Seniors.
    Coordinators are expected to vet both Seniors and Volunteers before inclusion in the group and assign an appropriate Volunteer to each Senior.
    Each Volunteer should agree to call the assigned Senior over the phone and have a good conversation on a regular basis.
    Seniors may report some needs to the Volunteer, which will be conveyed to the Coordinator for resolution.
    The phone calls between the Volunteers and Seniors may be beneficial for both Seniors and Volunteers, open the possibility for new relationships in the community, and help to ameliorate social isolation.</p>
  
  <p>Senior Link does not monitor any group or content. Groups are managed by their Coordinators without monitoring by Senior Link. Coordinators must obtain consent from Volunteers and Seniors before including them in their groups. Participants must obtain permission from Coordinators to participate in groups. The Senior Link Project does not monitor, neither participate in this process. By using the Senior Link Web App, website, or other related services, all users release Senior Link and its associates from any and all liabilities.</p>
  
  <p>
  If you do not agree to  these terms and conditions, you must immediately stop using the Senior Link Web App,  its website and other services provided by Senior Link. If you continue to use  or access the Senior Link Web App, website or access other services provided by Senior  Link, you agree to be bound by this Terms of Service. YOU MUST BE AT LEAST 18  YEARS OLD TO USE THE SERVICES, OR YOU MAY BE AT LEAST 13 YEARS OLD ALWAYS WITH YOUR  PARENT SUPERVISON WHEN USING THE SERVICES. IF YOU ARE UNDER THE AGE OF 13, USE  OF SENIOR LINK APPS, SITES AND SERVICES IS PROHIBITED.</p>

<p><strong>1. SENIOR LINK SERVICES</strong></p>
<p>
  Senior Link provides  services, content or products (&quot;Senior Link Services&quot;), which may  include Web App, websites, desktop software, online software, or other Internet  services, owned, controlled or operated by Senior Link Project or affiliated  with third parties.</p><p>
  Senior Link Services may  be provided to you under this agreement to facilitate the process of coordinators  connecting volunteers to seniors. Such services are  available for your personal, non-commercial use only.</p><p>
  You understand and agree  that Senior Link Services are provided &quot;as is&quot; and the Senior Link does  not monitor the group activity, contact information, and user data. All  participant information and data are provided by group coordinator and group  participants. You are responsible for obtaining access to the Senior Link  Services. That access may involve third party fees (such as ISP charges or  airtime charges). You are responsible for those fees, including those fees  associated with the display or delivery of advertisements. In addition, you  must provide and are responsible for all equipment necessary to access the Senior  Link Services.</p><p>
  The content of Senior  Link Services is protected by copyright laws and international treaty  provisions, as well as other intellectual property laws and treaties.</p>                    

  <p><strong>2. REGISTRATION OBLIGATIONS</strong></p><p>
  In consideration of your  use of the Senior Link Services you represent that you are of legal age to form  a binding contract and you are not a person barred from receiving services  under the laws of the United States or other applicable jurisdiction. You also  agree to provide true, accurate, current and complete information about  yourself as prompted by the Senior Link Services' registration process  (&quot;Registration Data&quot;) and to maintain and promptly update your  Registration Data to keep it true, accurate, current and complete. If you  provide any information that is untrue, inaccurate, not current or incomplete,  or if Senior Link has reasonable grounds to suspect that such information is  untrue, inaccurate, not current or incomplete, Senior Link has the right to  suspend or terminate your account and refuse all current or future use of the Senior  Link Services.</p>
<p><strong>3. OWNERSHIP</strong></p><p>
  You agree that the Senior  Link, and all intellectual property, title, copyrights, and proprietary rights  therein are owned by The Project,  including but not limited to any executable  software codes, images, photographs, animations, video, audio, music, and text  incorporated into Senior Link, the accompanying printed materials, and any  copies of the Services. The Project reserves title and all right and interests  in and to the Senior Link Services, including without limitation all patent  rights, copyrights, trademarks, trade names, trade secrets and other  intellectual property and proprietary rights. There are no implied licenses  under this agreement, and all rights not expressly granted are reserved by the  Project.</p>

  <p><strong>4. THIRD PARTY CONTENT, PRODUCTS AND SERVICES</strong></p><p>
  Senior Link may provide  links to affiliate companies (&quot;Third-Party Affiliate&quot;). Senior Link  does not assume any responsibility or liability for the content, product and  actions of all and any Third-Party Affiliate. If you decide to use a Third-Party  Affiliate services or products, you are responsible for reviewing and  understanding the terms and conditions governing any Third-Party Affiliate  services or products. Your participation in such Third-Party Affiliate services  or products indicates your acceptance of such terms and conditions. You agree  that the Third-Party Affiliate, and not Senior Link, is responsible for the  performance of the Third-Party Affiliate services and products. By downloading,  installing, or using products, content, or services from a Third-Party  Affiliate, you must agree to their terms and conditions and acknowledge and agree  that Senior Link does not guarantee that any download through Senior Link  Service will be free of viruses or other forms of corruptive code. Senior Link  expressly makes no representations or warranties concerning the performance,  effectiveness or any other aspect of any Third-Party Affiliate products and  services. In no event shall  Senior Link  (including its officers, directors, employees, affiliates and agents) be liable  for claims of any nature, whether direct or indirect, arising from or related  to any Third-Party Affiliate product or service accessed through the Senior  Link Services.</p>
<p><strong>5. USE OF PUBLICATIONS,  TRADEMARKS, AND LOGOS</strong></p>
<p>Senior Link provides information and resources on its website,  it may include articles, press releases, photographs, stories and case studies,  reports, newsletters, video broadcasts, e-newsletters, quarterly updates,  Unless otherwise expressly stated, all content provided on the Website is  intellectual property that belongs to the Project.</p>
<p>The Website/Web App intended use consists of a Group Owner who sets up the group, a Coordinator who inputs group  information and materials, invites Volunteers after curating them, and Seniors  who receive information about the group, the volunteer contacting them and a calling  plan if applicable. </p>
<p>You are permitted to download information from the Website for  your own personal informational use, but you may not use or duplicate any logos  or trademarks without express written permission from the project.</p>
<p>For any other use, you must obtain express written permission  from us.</p>
<p><strong>6. INTELLECTUAL PROPERTY AND PRIVACY</strong></p>
<p>6.1 You acknowledge and  agree that the Senior Link Services may electronically transmit certain  information to Senior Link automatically during the use of the Senior Link  Services, such as diagnostics, software/hardware configuration, and performance  data of the Senior Link Services. </p><p>
  6.2 Any information from  this transmission may be used by Senior Link to diagnose, improve, or correct  errors of the Senior Link Services. Senior Link Project does not monitor the  group activity, contact information, and user data. In fact, all participant  information and data are provided by group coordinator and group participants,  and by using the service, your email address, user Content and other  information will be stored on Senior Link's servers, and by using this feature  you expressly consent to this storage along with all other Senior Link terms of  service and privacy policy. As a condition of this agreement, Senior Link may  gather end-user registration and hardware and software version information  during activation of the certain parts of Senior Link Services. </p><p>
  6.2 You understand and  agree that you may not use the Senior Link Services to infringe upon or violate  the intellectual property, privacy, publicity or other rights of third parties,  including without limitation the rights in any sound recordings, songs, photographs,  artwork, and/or other copyrightable works of any kind or nature. </p><p>
  6.3 Senior Link  undertakes no obligation to review or screen any User information posted on the  Senior Link Server. However, Senior Link reserves the right to: (i) exam  records in the event of complaint or report of abuse; and/or (ii) terminate or  disable groups or users if warranted. </p><p>
  6.4 You agree that by  utilizing any service of Senior Link Services, you are agreeing to all terms of  service, privacy policies, and other policies of  said service, whether or not you have explicitly acknowledged those policies. Senior  Link reserves the right to stop or substitute any Senior Link Services, at any  time and for any reason.</p>
<p><strong>7. NO WARRANTIES</strong></p>
<p>Though we strive to keep the information available on the Senior  Link current and accurate, errors can occur. We provide the information on the  Website with no representations or guarantees of accuracy, completeness, or  timeliness. Senior Link will not be liable to you or any other person for any  damages that result from the use or inability to use the Website, or as a  result of any content, information, services, or resources made available  through the Website.</p>

<p><strong>8. LIMITATION OF LIABILITY</strong></p>
<p>To the maximum extent  permitted by applicable law, neither Senior Link nor its affiliates, licensees  or suppliers shall be liable for any incidental, special, consequential, or  indirect damages of any kind (including, without limitation, damages for  interruption of business, procurement of substitute goods, lost data, lost  profits, pecuniary losses, or the like) arising out of your use or inability to  use the Senior Link services (or any intellectual property subsisting therein)  or the provision of or failure to provide support services regardless of the  form of action, whether in contract, tort (including negligence), strict  product liability, or any other legal or equitable theory, even if the project  has been advised of the possibility of such damages. By signing up to the Web App  the users release Senior Link Project and associates from any and all  liability. Some jurisdictions do not allow the exclusion or limitation of incidental  or consequential damages so this limitation and exclusion may not apply to you.  to the extent that a party may not as a matter of applicable law limit its  liability, the scope and duration of such liability shall be the minimum  permitted by law. this limitation of liability will apply notwithstanding the  failure of essential purpose of any limited remedy set forth herein. </p>

<p><strong>9. INDEMNIFICATION</strong></p><p>
  You agree to indemnify  and hold harmless the Senior Link Project, its affiliates, officers, employees  and volunteers from and against all damages, liabilities, losses, costs and  expenses arising from or relating to your use or misuse of Senior Link or your  breach of this agreement.</p>
<p><strong>10. ABOUTS THESE TERMS – GENERAL PROVISIONS </strong></p>
<p>If we do not immediately  take action to address a violation of these Terms of Use, we are not waiving  our rights to take action in the future. If any particular provision of these  Terms of Use is found to be unenforceable, that provision will be severable and  will not affect any of the other provisions.</p><p>
  This Website is owned and  operated by from an office in California. Your use of the Senior Link, and any  related legal action, will be governed by the laws of the State of California,  without regard to conflict of laws principles. The sole jurisdiction for any  litigation arising out of your use of or inquiries to the Website will be an  appropriate federal or state court located in California. </p>
<p><strong>11. MODIFICATIONS OR AMENDMENTS TO THE TERMS OF USE </strong></p>
<p>Senior Link may reserve  the right to make changes to any information or services on its website,  including these Terms of Use, without notice to you. The most current Terms of  Use will be posted here on the website and will be effective upon posting. The  Effective Date will be posted with the most current Terms of Use. Be sure to  return to this page periodically to ensure familiarity with the most current  version of these Terms of Use.</p>
<p>&nbsp;</p>

                    <div className="text-center">
                        <Button
                            className="btn-wide mb-2 mr-2"
                            size="md"
                            color="primary"
                            onClick={toggleModalTermsConditions}
                        >
                            Close
                        </Button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={modalPrivay} toggle={toggleModalPrivacy}>
                <ModalHeader toggle={toggleModalPrivacy}>
                    Privacy Policy
                </ModalHeader>
                <ModalBody>

                <p>We take privacy  seriously and want you to feel comfortable using Senior Link. We collect  information from users to provide the best service to our customers. We will  not sell or provide any information from any user to any third party.</p><p>
  This page describes our  privacy policy (&quot;Privacy Policy&quot;), which applies to services or  content provided by Senior Link, which means websites and web applications  controlled or operated by Senior Link.</p><p>
  By visiting this  website or using Senior Link Services, you are accepting the practices  described in this Privacy Policy, as well our Terms of Use. If you do not agree  to this Privacy Policy or Terms of Use, please do not use Senior Link, visit  our website, or disclose any information to us.</p><p>
  <strong>Coordinators</strong></p><p>
  Senior Link protects  your information. The contact information for coordinators is limited to only  members of your group. Other coordinators, volunteers, and seniors in your  group can view your phone number and email if you participate in the group. </p>

  <p>
  <strong>Volunteers</strong></p><p>
  Senior Link protects  your information. The contact information for volunteers is limited to only  coordinators of your group and your assigned seniors. Coordinators and assigned  seniors in your group can view your phone number and email if you participate  in the group.</p><p>
  <strong>Seniors</strong></p><p>
  Senior Link protects  your information. The contact information for seniors is limited to only  coordinators of your group and your assigned volunteer. Coordinators and your  volunteer in your group can view your phone number and email if you participate  in the group.</p><p>
  <strong>Group Information</strong></p><p>
  All information  entered in the group information, files attached (release forms or other  permission slips), and script for volunteers is available only to the members  of the group. Senior Link will not share or sell any of this information to any  other third party.</p><p>
  <strong>Surveys</strong></p><p>
  Senior Link may pose  surveys to evaluate what features are useful and how we may best suit groups  that organize volunteers. This information is not shared with other  organizations and is only used to improve our web app.  Senior Link may also pose a survey for  volunteers to ask seniors, for example the question &ldquo;How have you been today?&rdquo;  and the volunteer may note down the seniors' response. The evaluation of the  seniors&rsquo; well-being will not be shared with anyone. It will solely be used to  understand how effective the program of reaching out to seniors has been.  Finally, Senior Link may provide optional questionnaires for participants. The  information collected from questionnaires will not be sold or shared in any  way. It will only be used to evaluate the program. De-identified data may be  used in aggregate form for research purposes without revealing any confidential information of  participants. All information in Senior Link data remains confidential.</p><p>
  This policy does not  apply to the practices of companies that Senior Link does not own or control,  nor does it apply to people that Senior Link does not employ or manage. Other  companies have their own privacy policies, and these can be viewed at their own  websites. Senior Link Services may contain links to other websites or services.  Senior Link is not responsible for the privacy practices or the content of such  other web sites or services.</p><p>
  <strong>Access to your  online content</strong></p><p>
  Creating password  protected areas for your account requires user registration and your  authorization/invitation to access your protected online content. As in any  password protected system, it is possible that a password might be transmitted  from one user to another, or a password may be discovered by another user, who  will have access to your protected online content. Therefore, we recommend you to  create a robust password for your account and change it frequently.</p><p>
  During normal  operations, Senior Link personnel or its partners may also see your online  content to process requested services, to maintain the online operation of  Senior Link Services, or to resolve potential problems with your account.</p><p>
  <strong>Information we  collect and how we use it</strong></p><p>
  Senior Link collects  your personal information when:</p>
<ol>
  <li>You register with Senior Link. </li>
  <li>You use Senior Link Services. </li>
  <li>You request support, materials, or  information from us. </li>
  <li>You send suggestions or questions  to us. </li>
  <li>You enter promotions or  participate in surveys. </li>
</ol>
<p>Senior Link  automatically receives and records information on our server logs from your  browser, including your IP address, cookie information, back link, and page  requested. General data about your computer may be also collected, such as its  operation system, web browser, screen resolution, etc.</p><p>
  Our most important  goal in collecting this information is to provide you with personalized and  user-friendly products and services.</p><p>
  In addition to using  this information to customize the Senior Link Services offered to you, Senior  Link uses this information to fulfill your requests, improve our services,  contact you, perform research, and create anonymous reporting and statistics  about the usage of Senior Link Services.</p><p>
  <strong>Cookies</strong></p><p>
  Senior Link may set  and access a small data file in your computer, known as a cookie, often  including a unique identifier, which is used by Senior Link for a number or  purposes, including:</p>
<ol>
  <li>Access your information when you  &quot;sign in,&quot; so that we can provide you with customized content. </li>
  <li>Display the most appropriate  advertising content, based on your interests and activity on Senior Link  Services. </li>
  <li>Estimate and report our total  audience size and traffic. </li>
  <li>Conduct research to improve Senior  Link content and services. </li>
</ol>
<p>Senior Link lets  certain other companies set and access their cookies on your computer. Other  companies' use of their cookies is subject to their own privacy policies, not  this one.</p><p>
  Senior Link Services  may include the use of Web beacons (electronic images such as single-pixel  gifs) to assist the delivery of cookies and/or allow us to obtain visit  statistics of Senior Link Website pages. Web beacons may be included in  promotional email messages or newsletters to determine whether messages were  opened and acted upon. Senior Link may also use Web beacons from third parties  to compile aggregated statistics and determine the effectiveness of marketing  campaigns.</p><p>
  <strong>Information Sharing</strong></p><p>
  Senior Link does not  rent, sell, or share your personal information to or with third parties, except  to provide services you have requested, or under the following circumstances:</p>
<ol>
  <li>We have your consent. </li>
  <li>We provide such information to  trusted partners who work on behalf of or with Senior Link under agreements. We  require that these third parties to protect your personal information based on  our instructions and in compliance with our policies. </li>
  <li>We believe it is necessary to  share information in order to meet any applicable law, regulation, legal  process or enforceable government request, (b) enforce Senior Link Terms of  Use, including investigation of potential violations thereof, (c) detect,  prevent, or address fraud, security or technical issues, or (d) protect against  imminent harm to the rights, property or safety of Senior Link, its users or  the public as required or permitted by law. </li>
  <li>We may transfer information about  you if Senior Link is acquired by or merged with another company. In this  event, Senior Link will notify you before your personal information is  transferred and becomes subject to a different privacy policy. </li>
</ol>
<p><strong>Security</strong></p><p>
  Senior Link applies  security measures to protect the communication of your personal information,  including secure socket layer (SSL) encryption. Senior Link also utilizes  several security technologies and procedures to protect your personal  information from unauthorized access, including appropriate physical,  electronic, and procedural safeguards to secure the information collected by  Senior Link Services.</p><p>
  <strong>Minors</strong></p><p>
  Senior Link services  are intended for general audiences over 18 years old. Users older than 13 years  old may use the services, if under their parent supervision at all times, when  using the services and when conducting related activities to the services.</p><p>
  <strong>Changes to this  Privacy Policy</strong></p><p>
  Senior Link may  update this Privacy Policy from time to time. Any updates to our Privacy Policy  will be linked from our home page. Your continued use of Senior Link Services  constitutes your agreement to this Privacy Policy and any updates. Please  periodically review this Privacy Policy to keep informed about how are working  to secure your personal information collected by Senior Link Services.</p><p>
  <strong>Questions and  Suggestions</strong></p><p>
  If you have any  additional questions or concerns about this Privacy Policy, please contact us  at: Senior Link - Attn. Privacy Policy - email: info @ senior.link</p>
                    
                    <div className="text-center">
                        <Button
                            className="btn-wide mb-2 mr-2"
                            size="md"
                            color="primary"
                            onClick={toggleModalPrivacy}
                        >
                            Close
                        </Button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={modalConfirm} toggle={toggleModalConfirm}>
                <ModalHeader toggle={toggleModalConfirm}>
                    Confirm your registration
                </ModalHeader>
                <ModalBody>
                    <p>
                        Senior Link curates Resources info and sources, but it does not monitor any group or content.
                        Groups are managed by their coordinators. By signing up,
                        you release Senior Link and its associates from any and
                        all liabilities, and agree that you are older than 18 years
                        (or older than 13 years always using this under your parent supervision).
                    </p>
                    <div className="text-center">
                        <Button
                            className="btn-wide mb-2 mr-2"
                            size="md"
                            color="success"
                            onClick={endSubmit}
                        >
                            I Agree
                        </Button>
                        <Button
                            className="btn-wide mb-2 mr-2"
                            size="md"
                            color="danger"
                            onClick={toggleModalConfirm}
                        >
                            Cancel
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </Fragment>
    );
}
